import RegisterExternalUserContainer from './RegisterExternalUserContainer';
export default RegisterExternalUserContainer;
